export const getCodePreviewValue = function getCodePreviewValue(val) {
  const globalState = this.getRootState()
  const parentPropsValue = this.parent.value
  const value = val || (parentPropsValue ?
    this.call('exec', parentPropsValue, this.parent) :
    this.call('exec', this.value, this))
  const framework = globalState?.framework === 'domql' ? 'symbols' : globalState?.framework
  const code = this.call('isObjectLike', value) ?
    value[framework] || value['symbols'] || value['domql'] :
    value
  if (!code) return
  const stringifiedCode = this.call('isString', code) ?
    code :
    this.call('objectToString', code)
  return this.call('replaceLiteralsWithObjectFields', stringifiedCode)
}